import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../../../../../common/react/utils/translations';

export const OverviewTableLinkCell = ({ player }) => {
    return (
        <td className="overview-table__data overview-table__data--link">
            {player?.playerId ? (
                <a
                    className="overview-table__link"
                    href={PULSE.app.common.url.getPlayerProfileURL(
                        player?.playerId
                    )}
                >
                    <span className="u-hide-until-tablet">
                        {getTranslation('label.statsCompare.profileLink')}
                    </span>
                    <span className="u-hide-from-tablet">
                        {getTranslation('label.statsCompare.profileLink.short')}
                    </span>
                </a>
            ) : (
                '-'
            )}
        </td>
    );
};

OverviewTableLinkCell.propTypes = { player: PropTypes.object };
